import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../../core/_base/crud';
import { PhieuKiemTra } from '../phieu-kiem-tra-model/phieu-kiem-tra.model';

const API_ROOT_URL = environment.ApiRoot + '/qaqc';

@Injectable()
export class PhieuKiemTraService {

	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});

	lastData$: BehaviorSubject<PhieuKiemTra[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/PhieuKiemTra_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDetail(itemId): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuKiemTra_Get_Detail?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getInfoMauKiemTra(idHH: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/MauPhieuKiemTra_Get_Detail_ByHH?IdHH=${idHH}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getSoPhieu(idLoaiHH: number = -1, idNhomHH: number = -1): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PKT_Get_SPByHH?idLoaiHH=${idLoaiHH}&idNhomHH=${idNhomHH}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuKiemTra_Delete?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	downloadTemplate(idFile: any): string {
		return API_ROOT_URL + `/PhieuKiemTra_DownFileDK?idFile=${idFile}`;
	}
	/*---------------------------------------------------------------------- */


	/*-------------------------------POST Method---------------------------- */
	add(item: PhieuKiemTra): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemTra>(API_ROOT_URL+'/PhieuKiemTra_Insert', item, { headers: httpHeaders });
	}
	updateWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemTra>(API_ROOT_URL+'/PhieuKiemTra_Update_With_Detail', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */


	/*------------------------------ Qui trình ----------------------------- */
	considerence(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemTra>(API_ROOT_URL+'/PhieuKiemTra_Considerence', item, { headers: httpHeaders });
	}
	confirm(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemTra>(API_ROOT_URL+'/PhieuKiemTra_Confirm', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
}
